// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2uiCw","header":"MergedInvoice_header__stS6-"};